import { render, staticRenderFns } from "./GrupoComissaoManage.vue?vue&type=template&id=2a1ffa38&scoped=true"
import script from "./GrupoComissaoManage.vue?vue&type=script&lang=js"
export * from "./GrupoComissaoManage.vue?vue&type=script&lang=js"
import style0 from "./GrupoComissaoManage.vue?vue&type=style&index=0&id=2a1ffa38&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a1ffa38",
  null
  
)

export default component.exports